import {State} from '../../types/state';
import {NameSpace} from '../root-reducer';

export const getLicense = (state: State): string => state[NameSpace.General].license;
export const getUserRole = (state: State): number => state[NameSpace.General].role;
